<template>
  <div class="wrapper">
    <div class="bitrix-app-header">
      <Logo class="logo" />
      <div class="user-block">
        <span class="email">{{ email }}</span>
        <Button variant="plain" class="btn" @click="logout">Выход</Button>
      </div>
    </div>
    <h1 class="bitrix-app-title">Мониторинг закупок</h1>
    <h2 class="bitrix-app-subtitle">Выбор полей для связи с полями Б24</h2>
    <div class="bitrix-app-fields">
      <div class="bitrix-app-deal-fields">
        <div class="title-wrapper">
          <h3 class="title">Сделка</h3>
        </div>
        <BitrixFieldMappingRow
          v-for="f in dealFields"
          :field="f"
          type="DEAL"
          @change="onFieldChange"
          :key="f.id"
        />
      </div>
      <div class="bitrix-app-lead-fields">
        <div class="title-wrapper">
          <h3 class="title">Лид</h3>
        </div>
        <BitrixFieldMappingRow
          v-for="f in leadFields"
          :field="f"
          type="LEAD"
          @change="onFieldChange"
          :key="f.id"
        />
      </div>
    </div>
    <div class="bitrix-app-footer">
      <Button
        class="bitrix-app-footer__button"
        @click="handleUpdateBitrixMapping"
        >Сохранить изменения</Button
      >
    </div>
  </div>
</template>

<script>
import Logo from "@/assets/icons/new-logo.svg";
import Button from "@/components/homePage/Button.vue";
import BitrixFieldMappingRow from "../../components/bitrix/BitrixFieldMappingRow.vue";
import { mapActions, mapGetters } from "vuex";
import { bitrixInstallPath } from "@/router/bitrix/install";
import {
  reinitCancelToken,
  source,
} from "@/application/requests/notificationsRequests";
import { loadBitrixScript } from "../../utils/loadBitrixScript.js";

export default {
  name: "BitrixApp",
  components: {
    Logo,
    Button,
    BitrixFieldMappingRow,
  },
  data() {
    return {
      mapping: {
        bitrixFields: {},
        mappings: {
          DEAL: [],
          LEAD: [],
        },
      },
    };
  },
  methods: {
    ...mapActions("bitrix", [
      "initBitrix",
      "getBitrixMapping",
      "updateBitrixMapping",
      "checkConnection",
    ]),
    ...mapActions("auth", ["logoutUser"]),
    ...mapActions(["clearAll"]),
    onFieldChange({ type, id, field, value }) {
      const list = this.mapping.mappings[type];

      const index = list.findIndex((item) => item.id === id);
      this.$set(list, index, {
        ...list[index],
        [field]: value,
      });
    },
    async handleUpdateBitrixMapping() {
      try {
        await this.updateBitrixMapping({
          memberId: this.bitrixAuth.member_id,
          payload: {
            mappings: {
              DEAL: this.stripFields(this.mapping.mappings.DEAL),
              LEAD: this.stripFields(this.mapping.mappings.LEAD),
            },
          },
        });
        this.$toast.success("Маппинг обновлен");
      } catch (e) {
        this.$toast.error(e.message);
      }
    },

    stripFields(fields) {
      const keysToRemove = ["id", "label", "fixed"];
      return fields.map((item) =>
        Object.fromEntries(
          Object.entries(item).filter(([key]) => !keysToRemove.includes(key)),
        ),
      );
    },
    logout() {
      this.logoutUser();
      this.clearAll();
      localStorage.clear();
      source.cancel();
      reinitCancelToken();
      this.$router.push(bitrixInstallPath);
    },
  },
  computed: {
    ...mapGetters("auth", ["email", "isAuthenticated"]),
    ...mapGetters("bitrix", [
      "isBitrix",
      "bitrixAuth",
      "isBitrixConnectionValid",
    ]),
    dealFields() {
      return this.mapping.mappings.DEAL;
    },
    leadFields() {
      return this.mapping.mappings.LEAD;
    },
    bitrixFields() {
      return this.mapping.bitrixFields;
    },
  },
  watch: {
    isBitrix: {
      async handler() {
        if (this.isBitrix) {
          console.log("IN BITRIX");
          try {
            this.mapping = await this.getBitrixMapping(
              this.bitrixAuth.member_id,
            );
            const checkConnectionData = await this.checkConnection(
              this.bitrixAuth.member_id,
            );

            console.log(checkConnectionData);
          } catch (e) {
            console.log("logout from isBitrix");
            this.logout();
          }
        }
      },
      immediate: true,
    },
    isAuthenticated: {
      immediate: true,
      async handler(value) {
        console.log("watch isAuthenticated", value);

        if (!value) {
          console.log("redirect to install from isAuthenticated");
          this.$router.push(bitrixInstallPath);
        }
      },
    },
    isBitrixConnectionValid: {
      immediate: true,
      handler(value) {
        console.log("watch isBitrixConnectionValid", value);
        if (!value) {
          console.log("logout from isBitrixConnectionValid");
          this.logout();
        }
      },
    },
  },
  async mounted() {
    try {
      await loadBitrixScript();
      this.initBitrix();
    } catch (e) {
      console.error("Ошибка загрузки API Битрикс24", e);
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: #484e55;
  padding: 20px;
  flex-direction: column;
  font-family: Montserrat;
  color: #fff;
  gap: 20px;
  .bitrix-app-header {
    .logo {
      height: 36px;
      width: 75px;
    }
    .user-block {
      display: flex;
      align-items: center;
      gap: 10px;
      .email {
        font-size: 16px;
        font-weight: 600;
        color: #fff;
      }
      .btn {
        height: 100%;
      }
    }
  }
  .bitrix-app-title {
    font-size: 32px;
    font-weight: 400;
  }
  .bitrix-app-subtitle {
    font-size: 16px;
    font-weight: 400;
  }
  .bitrix-app-subtitle {
    font-size: 24px;
    font-weight: 400;
  }
  .bitrix-app-fields {
    display: flex;
    gap: 30px;
    height: 100%;
    .bitrix-app-deal-fields,
    .bitrix-app-lead-fields {
      width: calc(50% - 15px);
      display: flex;
      flex-direction: column;
      gap: 10px;
      .title-wrapper {
        width: 100%;
        height: 40px;
        background: #857fcf;
        border-radius: 5px;
        display: flex;
        align-items: center;
        padding: 0 24px;
        .title {
          font-size: 16px;
          font-weight: 600;
        }
      }
    }
  }
  .bitrix-app-header,
  .bitrix-app-footer {
    display: flex;
    justify-content: space-between;
    height: 36px;
    width: 100%;
  }
  .bitrix-app-footer {
    height: 40px;
    width: 100%;
    margin-top: 16px;
    .bitrix-app-footer__button {
      height: 40px;
      padding: 0 24px;
    }
  }
}
</style>
